import { Link, Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "../src/pages/HomePage";
import Cursor from "./components/Cursor";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import AboutPage from "./pages/AboutPage";
import ContactUsPage from "./pages/ContactUsPage";
import ImagingService from "./components/Imaging Services/ImagingService";
import PaymentForm from "./components/MakePayment/PaymentForm";
import PatientForms from "./components/MakePayment/PatientForms";
import PatientReviews from "./components/MakePayment/PatientReviews";
import ForClinics from "./components/ForClinics/ForClinics";
import NotFound from "./components/NotFound";
import ScrollToTopButton from "./components/TopButton";
import SmoothScrollWrapper from "./components/SmoothScroll";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Accessibility from "./components/Accessibility";
import MedicalResource from "./components/MakePayment/MedicalResource";
import SpecialitiesPage from "./components/Imaging Services/SpecialitiesPage";
import Procedures from "./components/Procedures/Procedures";
import Header from "./components/Header";
import HipaaNotice from "./components/Hippa";
import TermsOfUse from "./components/TermsOfUse";
import Disclaimer from "./components/Disclaimer";
import AntiDiscr from "./components/AntiDiscr";
import ScrollToHashElement from "./components/ScrollHash";
import FooterTwo from "./components/FooterTwo";
import Attorney from "./components/Attorney";
function App() {
  useEffect(() => {
    setTimeout(() => {
      Aos.init({
        duration: 1000,
        once: true,
        easing: "ease-in-out",
      });
    }, 0);
  }, []);
  return (
    <SmoothScrollWrapper>
      <div>
        <div className="fixed top-3/4 right-6 -translate-y-1/2 z-30">
          <Link
            to="/contact"
            className="block origin-right rotate-90 bg-[#bf9c5e] text-white font-robout font-medium text-xl 
               px-5 py-3 rounded-br-md rounded-bl-md shadow-lg"
          >
            Contact Us
          </Link>
        </div>
        <Header />
        <Cursor />
        <ScrollToTopButton />
        <ScrollToHashElement offset={80} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/make-a-payment" element={<PaymentForm />} />
          <Route path="/for-patient" element={<PatientForms />} />
          <Route path="/patient-reviews" element={<PatientReviews />} />
          <Route path="/for-clinicians" element={<ForClinics />} />
          <Route path="/make-a-payment" element={<PaymentForm />} />
          <Route path="/services" element={<ImagingService />} />
          <Route path="/services/tests/:slug" element={<Procedures />} />
          <Route path="/privacy-statement" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/hippa" element={<HipaaNotice />} />
          <Route path="/accessibility-statement" element={<Accessibility />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/anti-discrimation" element={<AntiDiscr />} />
          <Route path="/attorney" element={<Attorney />} />
          <Route
            path="/medical-records"
            element={<MedicalResource />}
          />
          <Route
            path="/services/subspecialities/:slug"
            element={<SpecialitiesPage />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <FooterTwo />
      </div>
    </SmoothScrollWrapper>
  );
}
export default App;
